import momenJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import Loader from "react-loader-spinner";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, JournalText, List, PrinterFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { exportToExcel, invoiceTypesArray, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/Invoice";
import BihamtaTable from "../../Components/BihamtaTable";
import { getAllProductsInventoryTurnover, setTurnoverFilters } from "../store/api/ReportsAPI";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom, faWarehouse } from "@fortawesome/free-solid-svg-icons";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";

const InventoryTurnoverReportForAllProducts = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const [selectedStorage, selectStorage] = useState(null);
    const [popProducts, setPopProducts] = useState({ show: false });
    const [popStorage, setPopStorage] = useState({ show: false });
    const [groupBy, setGroupBy] = useState([]);
    const settingNames = ["ProductGrouppingType"];
    const { filterData, systemSettings } = useSelector(state => { return { filterData: state.ReportReducer.turnoverReportAllFilters, systemSettings: state.InvoiceReducer.systemSettings } })

    const [dateFilters, setDateFilters] = useState({
        ContactDateFrom: filterData?.ContactDateFrom,
        ContactDateTo: filterData?.ContactDateTo
    })
    const productGrouppingType = systemSettings && Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const { handleSubmit, register, errors } = useForm();
    const selectOptions = [
        { Value: "ShowStorage", Text: "به تفکیک انبار" },
        { Value: "ShowInvoiceType", Text: "به تفکیک فاکتور" },
        { Value: "ShowContactDate", Text: "به تفکیک تاریخ" }
    ]
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        const contactDateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        const contactDateTo = document.getElementsByName("ContactDateTo")[0].value;
        if (contactDateFrom !== '') {
            data.ContactDateFrom = dateFilters.ContactDateFrom;
        }
        if (contactDateTo !== '') {
            data.ContactDateTo = dateFilters.ContactDateTo;
        }
        if (data.ShowZNCounts && Array.isArray(data.ShowZNCounts)) {
            data.ShowZNCounts = data.ShowZNCounts.some(s => s === "on");
        }
        data.GroupByStorage = groupBy.includes("ShowStorage");
        data.GroupByInvoiceType = groupBy.includes("ShowInvoiceType");
        data.GroupByContactDate = groupBy.includes("GroupByContactDate");
        dispatch(getAllProductsInventoryTurnover(data))
    }
    function showModalStorage(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        e.preventDefault();
        if (filterData?.StorageName) {
            filterData.StorageName = null;
        }
        setPopStorage({
            show: true,
            setStorageData: selectStorage,
            value: e.key
        })
    }
    function toExcel() {
        const url = "api/StorageAPI/GetAllProductsInventoryTurnover";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("InventoryTurnoverReportAll", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        history.push({
            pathname: `/PrintViewer/InventoryTurnoverReportAll/${e.ctrlKey}`,
            state: {
                dataUrl: `api/StorageAPI/GetAllProductsInventoryTurnover`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function clearFilters() {
        frmFilters.current.reset();
        selectStorage(null);
        setDateFilters({
            ContactDateFrom: null,
            ContactDateTo: null
        })
        dispatch(getAllProductsInventoryTurnover({ Skip: 0, Take: 10 }));
    }
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "ProductCode", colTitle:"کد کالا" },
        { colName: "ProductType", colTitle: "نوع کالا", showCondition: () => productGrouppingType !== 1 },
        { colName: "ProductName", colTitle: "نام کالا", showCondition: () => productGrouppingType === 1 },
        { colName: "ProductModel", colTitle: "مدل کالا" },
        { colName: "StorageName", colTitle: "انبار", showInMobile: true, showCondition: () => groupBy.includes("ShowStorage") },
        { colName: "PInvoiceType", colTitle: "نوع فاکتور", showInMobile: true, showCondition: () => groupBy.includes("ShowInvoiceType") },
        { colName: "PContactDate", colTitle: "تاریخ فاکتور", showCondition: () => groupBy.includes("ShowContactDate") },
        { colName: "StartDurationInventory", colTitle: "موجودی اول دوره", colType: "currency", style:{direction:"ltr"} },
        { colName: "InventoryToDate", colTitle: "موجودی تا تاریخ" },
        { colName: "RowInventory", colTitle: "موجودی کل", style:{direction:"ltr"} },
        { colName: "MeanAvgPrice", colTitle: "میانگین موزون", colType: "currency" }
    ]
    function onGroupByChanges(item) {
        //const splited = item.value.split(",");
        if (item.checked) {
            if (!groupBy.includes(item.value)) {
                setGroupBy([...groupBy, item.value]);
            }
        }
        else {
            setGroupBy(groupBy.filter(a => !item.value.includes(a)));
        }
    }
    function showTurnover(row) {
if(Number(row.ProductID) >0 && Number(row.StorageID) > 0)
{
        dispatch(setTurnoverFilters({
            ProductID: row.ProductID,
            ProductName: row.ProductName,
            ProductModel: row.ProductModel,
            StorageName: row.StorageName,
            StorageID: row.StorageID,
            FromStorageStatus: true,
            Take: -1
        }))
        history.push(`/Sale/InventoryTurnoverReport`);
    }
    }
    useEffect(() => {
        document.body.classList = 'notMain';
        dispatch(getSystemSettings(settingNames));
    }, [])
    return (
        <div className="container-fluid mt-1">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faWarehouse} size="lg" />&nbsp;
                    گزارش جامع موجودی کالا
                </Card.Header>
                <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                <ModalProducts popData={popProducts} setProductPopup={setPopProducts} productGrouppingType={productGrouppingType} />
                <Card.Body className="bodyStyle">
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <input type="hidden" ref={register({})} name="StorageID" value={selectedStorage?.StorageID ?? filterData?.StorageID ?? ""} />
                                <Form.Control name="StorageName" ref={register({})} readOnly value={selectedStorage?.StorageName ?? filterData?.StorageName ?? ""} placeholder="نام انبار"
                                    onKeyDown={showModalStorage} />
                                <Button className="btn-input-tiny" style={{ top: "8px" }} onClick={showModalStorage}><List size={21} /></Button>
                            </Col>
                            <div className="col-md-2 form-group">

                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateFrom" placeholder="تاریخ فاکتور از"
                                    value={dateFilters.ContactDateFrom ? momenJalaali(dateFilters.ContactDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, ContactDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateTo" placeholder="تاریخ فاکتور تا"
                                    value={dateFilters.ContactDateTo ? momenJalaali(dateFilters.ContactDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ContactDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <Col md={2} className="form-group">
                                <BihamtaMultiSelect dataSource={selectOptions} valueItem="Value" displayItem="Text" onItemCheckChanged={onGroupByChanges} placeholder="نمایش به تفکیک" />
                            </Col>
                            <Col md={2} className="form-group">
                                <select className="form-control" defaultValue={filterData?.InvoiceType ?? ""} name="InvoiceType" ref={register({})}>
                                    <option value="">نوع فاکتور را انتخاب کنید</option>
                                    {invoiceTypesArray.map((type, i) => <option key={i} value={type.TypeName}>{type.TypeStr}</option>)}
                                </select>
                            </Col>
                        </Row>
                        <Button type="submit" variant="secondary" className="group-Btn-large mt-1"><JournalText size={18} />&nbsp;نمایش گزارش</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} filterData={filterData} reducerName="ReportReducer" objectName="invTurnoverReportAll"
                        className="mt-0 mb-0" maxHeight={500} rowClick={showTurnover}/>
                </Card.Body>
            </Card>
        </div>
    )

}
export default InventoryTurnoverReportForAllProducts
